<div>
  <iui-messages #messages class="ms-auto me-auto"> test </iui-messages>
</div>
<div class="container">
  <h1 class="col-md-4">Create an Account</h1>
  <h5 class="col-md-8 heading">The Account Holder organization is the CSC Registrant.</h5>
</div>
<div>
  <form #form1="ngForm" class='create' (keydown.enter)="handleEnter($event)">
    <div class="container sidebar-container" *ngIf="model">
      <div class="col-md-4">
        <div *ngFor="let sectionName of steps; let i = index" class="row">
          <span (click)="stepBack(i, i < step)" [ngClass]="{'step': true, 'completed': step > i, 'in-progress': step === i, 'next': step < i}">
            {{ sectionName }}
            <i [ngClass]="{'fa fa-circle-check': step > i}"></i>
          </span>
        </div>
      </div>
      <div class="col-md-8">
        <div>
          <!-- Personal Information -->
          <ng-template [ngIf]="step === 0">
            <div class="row">
              <label for="username" class="col-6 required">User ID</label>
              <div class="col-12">
                <input appScrText mask="A*" [appCheckClash]="checkUsername(username)" [(ngModel)]="model.username" autocomplete="username" name="username" id="username"
                  #username="ngModel" placeholder="User ID" minlength="6" required />

                <div *ngIf="username.dirty" class="error-msg">
                  <ng-template [ngIf]="username.errors?.changed">
                    <span [ngClass]="username.errors?.minlength || username.errors?.required ? 'failed' : 'passed'">
                      <i [ngClass]="username.errors?.minlength || username.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                      Be at least 6 characters
                    </span>
                  </ng-template>
                  <ng-template [ngIf]="!username.errors?.changed && !username.errors?.pending">
                    <span *ngIf="username.errors?.clash" class="failed">
                      <i class="fa fa-circle-xmark"></i>
                      This User ID is already in use
                    </span>
                    <span *ngIf="username.errors?.lockedOut" class="failed">
                      <i class="fa fa-circle-xmark"></i>
                      Too many failed attempts on the User ID field. Please wait.
                    </span>
                    <span *ngIf="!username.errors?.clash && !username.errors?.lockedOut" class="passed">
                      <i class="fa fa-circle-check"></i>
                      This User ID is available
                    </span>
                  </ng-template>
                  <ng-template [ngIf]="username.errors?.pending">
                    <i class="ms-3 fa fa-spin fa-spinner"></i>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="col-12">
                  <label for="password" class="col-12 required">Password</label>
                  <input appPassword [(ngModel)]="model.password" name="password" id="password" #password="ngModel" autocomplete="new-password" placeholder="Password" minlength="8"
                    [maxlength]="MaxLen.Password" pattern=".*[!@#$^_.,].*" appNoLeadingTrailingSpaces class="col-12 password"
                    (input)="confirmpassword.control.updateValueAndValidity()" required />
                </div>
                <div class="col-12">
                  <label for="confirmpassword" class="col-12 required">Confirm Password</label>
                  <input appPassword [(ngModel)]="dummy.password" [appExactMatch]="password" name="confirmpassword" autocomplete="new-password" id="confirmpassword"
                    #confirmpassword="ngModel" placeholder="Confirm Password" appNoLeadingTrailingSpaces class="col-12 password" (focus)="focusConfirmPassword()"
                    (blur)="blurConfirmPassword()" [maxlength]="MaxLen.Password" required />
                </div>

              </div>
              <div *ngIf="password.dirty" class="col-4 password-panel">
                <ng-template [ngIf]="password.invalid || !confirmPasswordFocused">
                  <div class="password-message">
                    <span *ngIf="password.invalid" class="password-invalid">Not a valid password!</span>
                    <span *ngIf="password.valid" [ngClass]="'password-'+passwordResult()">
                      This password is {{ passwordResult() }}!
                    </span>
                  </div>
                  <div [ngClass]="password.errors?.noLeadingTrailingSpaces ? 'failed' : 'passed'">
                    <i [ngClass]="password.errors?.noLeadingTrailingSpaces ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                    Cannot contain spaces at the beginning or end
                  </div>
                  <div [ngClass]="password.errors?.minlength || password.errors?.required ? 'failed' : 'passed'">
                    <i [ngClass]="password.errors?.minlength || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                    Be at least 8 characters
                  </div>
                  <div [ngClass]="password.errors?.pattern || password.errors?.required ? 'failed' : 'passed'">
                    <i [ngClass]="password.errors?.pattern || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                    Contain at least one of the following: ! &#64; # $ ^ _ . or ,
                  </div>
                </ng-template>
                <ng-template [ngIf]="password.valid && confirmPasswordFocused">
                  <div [ngClass]="confirmpassword.valid ? 'passed' : 'failed'">
                    <i [ngClass]="confirmpassword.valid ? 'fa fa-circle-check' : 'fa fa-circle-xmark'"></i>
                    Match the Password
                  </div>
                </ng-template>

              </div>
            </div>

            <div class="row mt-5">
              <label for="firstName" class="col-12 required">First Name</label>
              <div class="col-12">
                <input appScrText appFirstNameValidator [(ngModel)]="model.firstName" #firstName="ngModel" autocomplete="given-name" name="firstName" id="firstName"
                  placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />
                <app-error-msg [field]="firstName" fieldLabel="First Name"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="lastName" class="col-12 required">Last Name</label>
              <div class="col-12">
                <input appScrText appLastNameValidator [(ngModel)]="model.lastName" #lastName="ngModel" name="lastName" autocomplete="family-name" id="lastName"
                  placeholder="Last Name" maxlength="{{MaxLen.LastName}}" required />
                <app-error-msg [field]="lastName" fieldLabel="Last Name"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="email" class="required">Email</label>
              <div class="col-12">
                <input appEmail appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" [appCheckClash]="checkEmail(email)" [(ngModel)]="model.email" autocomplete="email" maxlength="{{MaxLen.Email}}" name="email"
                  id="email" #email="ngModel" placeholder="Email" (input)="confirmEmail.control.updateValueAndValidity()" required />

                <div *ngIf="email.dirty" class="error-msg">
                  <ng-template [ngIf]="email.errors?.changed">
                    <span *ngIf="!email.errors?.emailDomain"  [ngClass]="email.errors?.email ? 'failed' : 'passed'">
                      <i [ngClass]="email.errors?.email ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                      Be a valid email address
                    </span>
                    <span *ngIf="!email.errors?.email && email.errors?.emailDomain" [ngClass]="email.errors?.emailDomain ? 'failed' : 'passed'">
                      <i [ngClass]="email.errors?.emailDomain ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                      Email addresses may not use public domains
                    </span>
                  </ng-template>
                  <ng-template [ngIf]="!email.errors?.changed && !email.errors?.pending">
                    <span *ngIf="email.errors?.clash" class="failed">
                      <i class="fa fa-circle-xmark"></i>
                      This email address is already associated with an account in the Short Code Registry
                    </span>
                    <span *ngIf="!email.errors?.clash" class="passed">
                      <i class="fa fa-circle-check"></i>
                      This email address is valid
                    </span>
                  </ng-template>
                  <ng-template [ngIf]="email.errors?.pending">
                    <i class="ms-3 fa fa-spin fa-spinner"></i>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="row">
              <label for="confirmEmail" class="required">Confirm Email</label>
              <div class="col-12">
                <input appScrText appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" [(ngModel)]="dummy.email" #confirmEmail="ngModel" name="confirmEmail" maxlength="{{MaxLen.Email}}" id="confirmEmail" [appExactMatch]="email"
                  placeholder="Email" required />

                <div class="error-msg" *ngIf="confirmEmail.dirty && confirmEmail.invalid">
                  <span *ngIf="!confirmEmail.errors?.emailDomain" class="failed">
                    <i class="fa fa-circle-xmark"></i>
                    Email must match
                  </span>
                  <span *ngIf="confirmEmail.errors?.emailDomain" class="failed">
                    <i class="fa fa-circle-xmark"></i>
                    Email addresses may not use public domains
                  </span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-3 phone-section">
                <label for="phoneInput" class="required">Phone Number</label>
                <app-phone autocomplete="tel" [(ngModel)]="model.phone" #phone="ngModel" class="col-12" name="phone" required id="phone"></app-phone>
              </div>
              <div class="col-3 phone-section">
                <label for="extension">Extension</label>
                <input appScrText [(ngModel)]="model.phoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="extension" id="extension" autocomplete="tel-extension"
                  placeholder="Extension" />
              </div>
              <app-error-msg class="mt-5 col-5" [field]="phone" fieldLabel="Phone Number"></app-error-msg>
            </div>
          </ng-template>



          <!-- Organization Info -->
          <ng-template [ngIf]="step === 1">

            <div class="row">
              <label for="company" class="col-6 required">Organization Name</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.company" name="company" id="company" placeholder="Organization Name" maxlength="{{MaxLen.Company}}" required
                  autocomplete="organization" />
              </div>
            </div>
            <div class="row">
              <label for="country" class="col-6 required">Country</label>
              <div class="col-12">
                <app-country-dropdown autocomplete="country-name" name="country" id="country" [(ngModel)]="model.country"></app-country-dropdown>
              </div>

            </div>
            <div class="row">
              <label for="address1" class="col-6 required">Organization Address 1</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.address1" name="address1" id="address1" autocomplete="address-line1" placeholder="Organization Address 1"
                  maxlength="{{MaxLen.Address}}" required />
              </div>

            </div>
            <div class="row">
              <label for="address2" class="col-6">Organization Address 2</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.address2" name="address2" id="address2" autocomplete="address-line2" placeholder="Organization Address 2"
                  maxlength="{{MaxLen.Address}}" />
              </div>

            </div>
            <div class="row">
              <label for="city" class="col-6 required">City</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.city" name="city" id="city" placeholder="City" autocomplete="address-level2" maxlength="{{MaxLen.City}}" required />
              </div>
            </div>
            <div class="row">
              <label for="state" class="col-6" [ngClass]="{required: model.country === 'ca' || model.country === 'us'}">
                State/Province
              </label>
              <div class="col-12">
                <app-region-dropdown name="state" id="state" [(ngModel)]="model.state" [country]="model.country">
                </app-region-dropdown>
              </div>
            </div>
            <div class="row">
              <label for="zipInput" class="col-12" [ngClass]="{required: model.country === 'us' || model.country === 'ca'}">Zip/Postal Code</label>
              <div class="col-6">
                <app-zipcode-input name="zip" id="zip" inputId="zipInput" [(ngModel)]="model.zip" [country]="model.country" #zipModel="ngModel" autocomplete="postal-code">
                </app-zipcode-input>
              </div>
              <div class="col-6">
                <app-error-msg [field]="zipModel" fieldLabel="Zip/Postal Code"></app-error-msg>
              </div>
            </div>

            <div class="row">
              <label for="messagingRole" class="required col-12">What best describes your organization's<br/>role in the short codes messaging ecosystem?</label>
              <div class="col-6">
                <p-dropdown appDd placeholder="Select Messaging Role" [maxlength]="50" [options]="ecosystemRoles" [required]="true" id="messagingRole"
                  name="messagingRole" #messagingRole="ngModel" [(ngModel)]="model.messagingRole"></p-dropdown>
              </div>
              <div class="col-6">
                <app-error-msg [field]="messagingRole" fieldLabel="Messaging Role"></app-error-msg>
              </div>
            </div>

            <div class="row">
              <label for="legalEntityType" class="col-12 required">Legal Entity Type</label>
              <div class="col-6">
                <p-dropdown [editable]="true" appDd placeholder="Legal Entity Type" [maxlength]="45" [options]="legalEntityTypes" [required]="true" id="legalEntityType"
                  name="legalEntityType" #legalEntityType="ngModel" [(ngModel)]="model.legalEntityType" (onChange)="onChangeDropdown($event)"></p-dropdown>
                <div class="form-text">
                  <small>
                    The Legal Entity Type indicates your organization's financial business structure.
                    Typically your accounting department will have this information. <br />
                    Please contact support {{ customerSupportPhone }} if you need assistance.
                  </small>
                </div>
              </div>
              <div class="col-6">
                <app-error-msg [field]="legalEntityType" fieldLabel="Legal Entity Type"></app-error-msg>
              </div>
            </div>

            <div class="row">
              <label for="companyUrl" class="col-6 required">Organization URL</label>
              <div class="col-12">
                <input appScrText appUrlValidator [(ngModel)]="model.companyUrl" name="companyUrl" id="companyUrl" autocomplete="url" #companyUrl="ngModel"
                  placeholder="Organization URL" maxlength="{{MaxLen.CompanyUrl}}" required />
                <app-error-msg [field]="companyUrl" fieldLabel="Organization URL"></app-error-msg>
              </div>
            </div>

            <div class="row">
              <label for="companySymbol" class="col-6">Stock Market Symbol</label>
              <div class="col-12">
                <input appScrText appUppercase [(ngModel)]="model.companySymbol" name="companySymbol" id="companySymbol" #companySymbol="ngModel" mask="AAAAA"
                  pattern=".*[A-Za-z].*" [validation]="false" placeholder="Stock Market Symbol" />

                <div class="error-msg">
                  <ng-template [ngIf]="companySymbol.dirty && companySymbol.invalid && !companySymbol.errors?.required">
                    <span class="failed">
                      must be between 1 and 5 alphanumeric characters
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="row">
              <label for="estimatedAnnualRevenueInput" class="col-12">Estimated Annual Revenue</label>
              <div class="col-6">
                <p-inputNumber appIn #estimatedAnnualRevenue="ngModel" mode="currency" currency="USD" locale="en-US" 
                [(ngModel)]="model.estimatedAnnualRevenue" name="estimatedAnnualRevenue" id="estimatedAnnualRevenue"
                placeholder="Estimated Annual Revenue (in USD)"></p-inputNumber>
                <div class="form-text">
                  <small>
                    You are not required to provide this information to create an account, but some program incentives
                    may be available to your account based upon the information entered here.
                  </small>
                </div>
              </div>
              <div class="col-6">
                <app-error-msg [field]="estimatedAnnualRevenue" fieldLabel="Estimated Annual Revenue"></app-error-msg>
              </div>
            </div>

            <div class="row">
              <label for="fein" class="required col-5">Federal Tax ID (Format: ##-#######)</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.fein" name="fein" id="fein" mask="00-0000000" [dropSpecialCharacters]="false" placeholder="Federal Tax ID FEIN" #fein="ngModel"
                  required />
                <span class="error-msg" *ngIf="fein.touched && fein.invalid">
                  <span class="failed">is invalid. Valid format is ##-#######</span>
                </span>
                <div class="form-text"><small>
                    Federal employer ID number (FEIN) is used to identify your organization's account. <br />
                    Typically your accounting department will have this information. <br />
                    Please contact support {{ customerSupportPhone }} if you need assistance.
                  </small>
                </div>
              </div>
            </div>
            
            <div class="row">
              <label for="duns" class="col-6">Dun & Bradstreet Number (Format: 9 Digits)</label>
              <div class="col-12">
                <input style="width: 50%" appScrText [(ngModel)]="model.duns" name="duns" id="duns" mask="000000000" placeholder="DUNS Number" #duns="ngModel" />
                <span class="error-msg" *ngIf="duns.touched && duns.invalid">
                  <span class="failed">is invalid. Valid format is #########</span>
                </span>
                <div class="form-text"><small>
                    The Dun & Bradstreet Number is a unique 9-digit number that is used to identify your organization's account.
                    <br />
                    Typically your accounting department will have this information. <br />
                    Please contact support {{ customerSupportPhone }} if you need assistance.
                  </small>
                </div>
              </div>
            </div>

            <div class="row">
              <label for="giin" class="col-12">Global Intermediary Identification Number (Format: XXXXXX.XXXXX.XX.XXX)</label>
              <div class="col-12">
                <input appUppercase appScrText #giin="ngModel" [(ngModel)]="model.giin" name="giin" id="giin" placeholder="GIIN" maxlength="19" mask="AAAAAA.AAAAA.AA.000"
                  [dropSpecialCharacters]="false" pattern="[A-NP-Z\d]{6}\.[A-NP-Z\d]{5}\.(LE|SL|ME|BR|SP|SF|SD|SS|SB)\.\d{3}" [validation]="false" />
                <app-error-msg [field]="giin" fieldLabel="GIIN"></app-error-msg>

              </div>
              <div class="form-text"><small>
                  If your organization has been assigned a Global Intermediary Identification Number, please provide that number here. <br />
                  Typically your accounting department will have this information. <br />
                  Please contact support {{ customerSupportPhone }} if you need assistance.
                </small>
              </div>
            </div>

            <div class="row">
              <label for="lei" class="col-6">Legal Entity Identifier (Format: 20 Characters)</label>
              <div class="col-12">
                <input appUppercase appLei appScrText #lei="ngModel" [(ngModel)]="model.lei" name="lei" id="lei" placeholder="LEI" maxlength="20" pattern="[A-Z\d]{18}\d{2}" />
                <app-error-msg [field]="lei" fieldLabel="LEI"></app-error-msg>
              </div>
              <div class="form-text">
                <small>
                  The Legal Entity Identifier is a reference code used to identify
                  a legally distinct entity in a financial transaction.
                  <br />
                  Typically your accounting department will have this information. <br />
                  Please contact support {{ customerSupportPhone }} if you need assistance.
                </small>
              </div>
            </div>


          </ng-template>

          <ng-template [ngIf]="step === 2 ">
            <div class="row">
              <button class="col-auto btn btn-primary btn-sm mb-4" (click)="copyBillingInfo(true)">
                Copy from Previous Pages
              </button>
            </div>

            <div class="row">
              <label for="billingFirstName" class="col-6 required">First Name</label>
              <div class="col-12">
                <input appScrText appFirstNameValidator [(ngModel)]="model.billingFirstName" #billingFirstName="ngModel" name="billingFirstName" id="billingFirstName"
                  placeholder="First Name" autocomplete="billing given-name" maxlength="{{MaxLen.FirstName}}" required />
                <app-error-msg class="display:inline-block" [field]="billingFirstName" fieldLabel="First Name">
                </app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="billingLastName" class="col-6 required">Last Name</label>
              <div class="col-12">
                <input appScrText appLastNameValidator [(ngModel)]="model.billingLastName" #billingLastName="ngModel" name="billingLastName" id="billingLastName"
                  placeholder="Last Name" maxlength="{{MaxLen.LastName}}" required autocomplete="billing family-name" />
                <app-error-msg [field]="billingLastName" fieldLabel="Last Name"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="billingCountry" class="col-6 required">Country</label>
              <div class="col-12">
                <app-country-dropdown name="billingCountry" id="billingCountry" [(ngModel)]="model.billingCountry" #billingCountry="ngModel"
                  (ngModelChange)="billingCountryChanged()"></app-country-dropdown>
                <app-error-msg [field]="billingCountry" fieldLabel="Country"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <div class="col-3 phone-section">
                <label for="billingPhoneInput" class="required">Phone Number</label>
                <app-phone [(ngModel)]="model.billingPhone" #billingPhone="ngModel" class="col-12" name="billingPhone" required id="billingPhone"
                  autocomplete="billing tel"></app-phone>
              </div>
              <div class="col-3 phone-section">
                <label for="billingExtension">Extension</label>
                <input appScrText [(ngModel)]="model.billingPhoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="billingExtension" id="billingExtension" placeholder="" />
              </div>
              <div class="mt-5 col-5">
                <app-error-msg [field]="billingPhone" fieldLabel="Phone Number"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="billingEmail" class="col-6 required">Email</label>
              <div class="col-12">
                <input appEmail appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" [(ngModel)]="model.billingEmail" #billingEmail="ngModel" autocomplete="billing email" maxlength="{{MaxLen.Email}}"
                  name="billingEmail" id="billingEmail" placeholder="Email" required />
                <app-error-msg [field]="billingEmail" fieldLabel="Email"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="billingAddress1" class="col-6 required">Billing Address 1</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.billingAddress1" #billingAddress1="ngModel" name="billingAddress1" autocomplete="billing address-line1" id="billingAddress1"
                  placeholder="Billing Address" maxlength="{{MaxLen.Address}}" required />
                <app-error-msg [field]="billingAddress1" fieldLabel="Billing Address 1"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="billingAddress2" class="col-6">Billing Address 2</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.billingAddress2" name="billingAddress2" id="billingAddress2" autocomplete="billing address-line2"
                  placeholder="Billing Address 2" maxlength="{{MaxLen.Address}}" />
              </div>
            </div>
            <div class="row">
              <label for="billingCity" class="col-6 required">City</label>
              <div class="col-12">
                <input appScrText [(ngModel)]="model.billingCity" #billingCity="ngModel" name="billingCity" autocomplete="billing address-level2" id="billingCity"
                  placeholder="City" maxlength="{{MaxLen.City}}" required />
                <app-error-msg [field]="billingCity" fieldLabel="City"></app-error-msg>
              </div>
            </div>
            <div class="row">
              <label for="billingStateInput" class="col-6" [ngClass]="{required: model.billingCountry === 'us' || model.billingCountry === 'ca'}">
                State/Province
              </label>
              <div class="col-12">
                <app-region-dropdown name="billingState" id="billingState" #billingStateModel="ngModel" [(ngModel)]="model.billingState"
                  [country]="model.billingCountry"></app-region-dropdown>
                <app-error-msg [field]="billingStateModel"></app-error-msg>
              </div>

            </div>
            <div class="row">
              <label for="billingZipInput" class="col-6" [ngClass]="{required: model.billingCountry === 'us' || model.billingCountry === 'ca'}">Zip/Postal
                Code</label>
              <div class="col-12">
                <app-zipcode-input name="billingZip" id="billingZip" [(ngModel)]="model.billingZip" autocomplete="billing postal-code" inputId="billingZipInput"
                  [country]="model.billingCountry" #billingZipModel="ngModel"></app-zipcode-input>
                <app-error-msg [field]="billingZipModel" fieldLabel="Zip/Postal Code"></app-error-msg>
              </div>
            </div>

          </ng-template>

          <ng-template [ngIf]="step === 3 ">
            <div class="row">
              <label for="programTypeStandard">
                <input type="radio" name="programType" id="programTypeStandard" value="Standard" [(ngModel)]="model.programTypeRequested" (change)="programTypeChanged()" />
                Standard
              </label>

            </div>
            <div class="row ms-1 mb-4">
              Select the Standard program type if your organization qualifies neither as a Government entity nor a
              Charitable Organization.
            </div>
            <div class="row">
              <label for="programTypeGovernment">
                <input type="radio" name="programType" id="programTypeGovernment" value="Government" [(ngModel)]="model.programTypeRequested" (change)="programTypeChanged()" />
                Government
              </label>

            </div>
            <div class="row ms-1 mb-4">
              Select the Government program type if your organization qualifies as a U.S. Government entity. Additional
              information is required.
              <div *ngIf="model.programTypeRequested === 'Government'" class="expanded-selection">
                <div class="mb-1">
                  <label for='agencyType' class="col-auto required">Agency Type</label>
                </div>
                <div class="mb-1 radio-buttons">
                  <label for="agencyTypeFederal">
                    <input type="radio" name="agencyType" id="agencyTypeFederal" [(ngModel)]="model.governmentAgencyType" value="Federal" />
                    Federal
                  </label>

                  <label for="agencyTypeTribal">
                    <input type="radio" name="agencyType" id="agencyTypeTribal" [(ngModel)]="model.governmentAgencyType" value="Tribal" />
                    Tribal
                  </label>

                </div>
                <div class="mb-1 radio-buttons">
                  <label for="agencyTypeState">
                    <input type="radio" name="agencyType" id="agencyTypeState" [(ngModel)]="model.governmentAgencyType" value="State" />
                    State
                  </label>

                  <label for="agencyTypeOther">
                    <input type="radio" name="agencyType" id="agencyTypeOther" [(ngModel)]="model.governmentAgencyType" value="Other" (change)="agencyTypeChanged()" />
                    Other
                  </label>

                </div>
                <div class="mb-1 radio-buttons">
                  <label for="agencyTypeLocal">
                    <input type="radio" name="agencyType" id="agencyTypeLocal" [(ngModel)]="model.governmentAgencyType" value="Local" />
                    Local
                  </label>

                </div>
                <input type="text" name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" required hidden />

                <div class="mb-1" *ngIf="model.governmentAgencyType === 'Other'">
                  <label for="governmentExplain" class="col-6 required">
                    Other: Explain</label>
                  <div class="col-12">
                    <input class="col-12" appScrText placeholder="Other" name="governmentExplain" id="governmentExplain" [(ngModel)]="model.governmentExplain" maxlength="100"
                      required />
                  </div>
                </div>
                <div class="mb-1">
                  <label for="agencyWebsite">Agency Web Site</label>
                  <div>
                    <input appScrText appUrlValidator placeholder="URL" name="agencyWebsite" id="agencyWebsite" [(ngModel)]="model.governmentAgencyWebsite" #agencyWebsite="ngModel"
                      maxlength="150" />
                    <app-error-msg [field]="agencyWebsite" fieldLabel="Agency Web Site"></app-error-msg>
                  </div>

                </div>
                <div class="mb-1">
                  <label for="agencyInfo">
                    Additional Information
                  </label>
                  <textarea class="form-control" cols="40" rows="8" name="agencyInfo" id="agencyInfo" [(ngModel)]="model.governmentAdditionalInfo" maxlength="1024"></textarea>
                </div>
                <div class="mb-1">
                  <label for="governmentTerms" class="required">
                    <input type="checkbox" name="governmentTerms" id="governmentTerms" [(ngModel)]="dummy.governmentTerms" required />
                    Terms & Conditions
                  </label>

                </div>
                <div class="mb-1 ms-1 mb-4">
                  <span>
                    I have read and accept the Government Program Terms & Conditions
                  </span>
                </div>
                <div class="mb-1 ms-1 mb-4">
                  <span>
                    This program is available to qualified U.S. government entities only.
                    Your request will be reviewed and an email will be sent to you upon completion of the review.
                    You may be required to present documentation as proof of your status, in which case you will be
                    contacted by iconectiv.
                    Your account will not be able to lease any new short codes under the government pricing program
                    prior
                    to completion of this review.
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <label for="programTypeCharity">
                <input type="radio" name="programType" id="programTypeCharity" value="Charity" [(ngModel)]="model.programTypeRequested" (change)="programTypeChanged()" />
                Charitable Organization
              </label>

            </div>
            <div class="row ms-1 mb-4">
              <span>
                Select the Charitable Organization program type if your organization qualifies as a 501(c)(3) entity
                that is accredited by the
                <a href="http://give.org" target="_blank">Better Business Bureau's Wise Giving Alliance</a>, or
                has at least 3 stars on <a href="http://charitynavigator.org" target="_blank">Charity Navigator</a>.
                Additional information is required.
              </span>
              <div *ngIf="model.programTypeRequested === 'Charity'" class="expanded-selection mt-2">
                <div class="mb-3">
                  <label for='charityAccreditation' class="required">Accreditation Organization</label>
                </div>
                <div class="mb-2">
                  <label for="charityAccreditationBBB">
                    <input type="radio" name="charityAccreditation" id="charityAccreditationBBB" [(ngModel)]="model.charityAccreditation" value="BBB" checked />
                    Better Business Bureau Wise Giving Alliance
                  </label>

                </div>
                <div class="mb-3">
                  <label for="charityAccreditationCN34">
                    <input type="radio" name="charityAccreditation" id="charityAccreditationCN34" [(ngModel)]="model.charityAccreditation" value="CN34" />
                    Charity Navigator 3 or 4 Stars
                  </label>

                </div>
                <input type="text" name="charityAccreditation" id="charityAccreditation" [(ngModel)]="model.charityAccreditation" required hidden />
                <div class="row ms-1 mb-4">
                  <span>
                    Note: Your organization's 501(c)(3) status can be confirmed by visiting
                    <a href="http://www.irs.gov/app/pub-78/" target="_blank">http://www.irs.gov/app/pub-78/</a> or by
                    confirming your organization's status
                    by calling the IRS at 1-877-829-5500.
                  </span>
                </div>
                <div class="mb-1">
                  <label for="charityAdditionalInfo">Additional Information</label>
                  <textarea class="form-control" rows="10" name="charityAdditionalInfo" id="charityAdditionalInfo" [(ngModel)]="model.charityAdditionalInfo"
                    maxlength="1024"></textarea>
                </div>
                <div class="mb-1">
                  <label for="charityTerms" class="required">
                    <input type="checkbox" name="charityTerms" id="charityTerms" [(ngModel)]="dummy.charityTerms" required />
                    Terms & Conditions
                  </label>

                </div>
                <div class="row ms-1 mb-4">
                  <span>
                    I have read and accept the Charitable Organization Program Terms & Conditions
                  </span>
                </div>
                <div class="row ms-1 mb-4">
                  <span>
                    This program is available to qualified 501(c)(3) entities only.
                    Your request will be reviewed and an email will be sent to you upon completion of the review.
                    You may be required to present documentation as proof of your status, in which case you will be
                    contacted by iconectiv.
                    Your account will not be able to lease any new short codes under the Charitable Organization program
                    prior to completion of this review.
                  </span>
                </div>
              </div>
            </div>

            <input name="programType" id="programType" [(ngModel)]="model.programTypeRequested" required hidden />

            <hr />

            <!-- <ng-template> -->
            <div class="row">
              <label for="termAgreement" class="required">
                <input type="checkbox" name="termAgreement" id="termAgreement" [(ngModel)]="termAgreement" required />
                Terms & Conditions
              </label>
            </div>
            <div class="row ms-2 mb-4">
              <div class="col-auto">
                <span>
                  I have read and accept the <a [href]="licenseAgreementcontent" target="_blank">Short Code Registry's Registrant Sublicense Agreement</a> (last updated
                  {{licenseAgreementDate}})
                </span>
                <div class="terms">I acknowledge and agree that by clicking to accept the Registrant Sublicense Agreement that I am solely responsible for the accuracy
      and completeness of the information provided to the Short Code Registry, including without limitation my application information.</div>
              </div>
            </div>
            <div class="row">
              <label for="bestPractices" class="required">
                <input type="checkbox" name="bestPractices" id="bestPractices" [(ngModel)]="bestPractices" required />
                Best Practices
              </label>
            </div>
            <div class="row ms-2 mb-4">
              <div class="col-auto">
                <span>
                  I have read and accept the <a [href]="bestPracticesContent" target="_blank">Messaging Principles and Best
                    Practices</a> (last updated
                  {{ bestPracticesDate }})
                </span>
              </div>
            </div>
            <!-- </ng-template> -->

            <re-captcha *ngIf="recaptchaEnabled" name="captcha" id="captcha" [(ngModel)]="captcha" #recaptcha="ngModel" required></re-captcha>

          </ng-template>

        </div>
        <div class="row">
          <div class="col-auto">
            <button *ngIf="step < steps.length - 1" [disabled]="form1.invalid" (click)="advance()" class="btn mt-4"
              [ngClass]="{'btn-primary': form1.valid, 'btn-outline-primary': form1.invalid}">
              Continue to {{ steps[step + 1] }}
            </button>
            <app-help-link-icon *ngIf="!(step === steps.length - 1)" [helpPath]="'CreateAccount'" [customClass]="'ms-1'"></app-help-link-icon>
            <button *ngIf="step === steps.length - 1" [disabled]="form1.invalid" (click)="createAccount()" class="btn mt-4"
              [ngClass]="form1.invalid ? 'btn-outline-primary' : 'btn-primary'">
              Create my Account
            </button>
            <app-help-link-icon *ngIf="step === steps.length - 1" [helpPath]="'CreateAccount'" [customClass]="'ms-1'"></app-help-link-icon>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>